import { Injectable } from '@angular/core';
import { isDownloadable, mapTypeToIcon } from 'src/app/helpers';
import { IAdapter, IItemStructureDTO } from 'src/app/models';
import { ItemRevision, ItemRevisionDataset, ItemStructure } from 'src/app/models/domain';
import { ItemRevisionReferenceAdapter } from './item-revision-reference-adapter';

@Injectable({
  providedIn: 'root',
})
export class ItemStructureAdapter implements IAdapter<ItemStructure, IItemStructureDTO> {
  public constructor(private readonly itemRevisionReferenceAdapter: ItemRevisionReferenceAdapter) {}

  public adaptToDomain(itemStructureChild: IItemStructureDTO): ItemStructure {
    return new ItemStructure(
      itemStructureChild.itemId,
      itemStructureChild.itemName,
      itemStructureChild.itemType,
      (itemStructureChild.revisions ?? []).map(
        (revision) =>
          new ItemRevision(
            (revision.datasets ?? []).map(
              (datasets) =>
                new ItemRevisionDataset(
                  datasets.name,
                  datasets.relation,
                  mapTypeToIcon(datasets.type),
                  isDownloadable(datasets.type) ? datasets.link : undefined
                )
            ),
            [],
            (revision.references ?? []).map((reference) =>
              this.itemRevisionReferenceAdapter.adaptToDomain(reference)
            ),
            revision.releaseStatus,
            revision.revId,
            revision.chgShortNote ?? '',
            revision.revDesc ?? '',
            revision.chgNote ?? '',
            revision.chgNumber ?? ''
          )
      )
    );
  }
}
